import styled from 'styled-components';
import { COLORS } from '@/theme';
import { Select } from '@/ui';

export const StyledFilterRow = styled.tr`
  &&& {
    th {
      background-color: ${COLORS.LIGHTEST_GRAY};
      padding: 1rem 0.5rem;
      font-weight: normal;
    }
    th:last-child {
      border-right: none;
    }
  }
`;

export const StyledSelect = styled(Select)`
  &&& {
    min-height: 40px;

    .ant-select-selection-placeholder {
      color: ${COLORS.BLACK};
    }

    .ant-select-selector {
      overflow: hidden;
      padding-top: 0.15rem;
    }

    .ant-select-selection-overflow {
      flex-wrap: nowrap !important;
      overflow: hidden;
      white-space: nowrap;

      & .ant-select-selection-overflow-item span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 8vw;
      }

      & .ant-select-selection-overflow-item-rest div {
        border: none;
        color: ${COLORS.GRAY_PRIMARY};
      }

      & .ant-select-selection-overflow-item-suffix {
        padding-left: 0.25rem;
      }
    }

    .ant-select-clear {
      inset-inline-end: 0.25rem;
      top: 50%;
      width: fit-content;
      height: fit-content;
    }
  }
`;
